/* ==========================================================================
   FR product-page Shop Pay Installments  —  assets/fr-product-payment-terms.js

   Hides the installments banner while a Subscribe & Save plan is selected,
   and brings it back on one-time purchase. Shop Pay Installments cannot pay
   for a subscription, so the offer must not be on screen while a plan is
   chosen — the same rule already applied at the cart in
   snippets/fr-cart-payment-terms.liquid.

   THE SIGNAL, established by driving the real widget rather than assuming:

     The Shopify Subscriptions app block renders radios named
     purchaseOption_<sectionId>_<variantId>, and keeps every
     input[name="selling_plan"] on the page in sync with the choice.

       one-time selected ....... all selling_plan inputs are ""
       "Deliver every month" ... all become "692083523901"
       back to one-time ........ all return to ""

     selling_plan is what actually gets submitted to /cart/add, so it is the
     authoritative signal — more reliable than radio order or label text,
     which a merchant can reorder or rename.

   WHY THE DELAYED RE-CHECKS: the app updates selling_plan in its own handler,
   which does not necessarily run before ours, and it does not fire an event
   we can hook. So each interaction re-evaluates on a short ladder rather than
   once. Setting .value from script also mutates no attribute, so a
   MutationObserver on attributes would never see it — the observer below
   watches the widget for re-renders, not for the value itself.
   ========================================================================== */

(function () {
  if (window.__frProductPaymentTermsInit) return;
  window.__frProductPaymentTermsInit = true;

  var RECHECK_MS = [0, 120, 400, 900];

  function subscriptionSelected() {
    var inputs = document.querySelectorAll('input[name="selling_plan"]');
    for (var i = 0; i < inputs.length; i++) {
      if (String(inputs[i].value || '').trim() !== '') return true;
    }
    return false;
  }

  function apply() {
    var hide = subscriptionSelected();
    var els = document.querySelectorAll('[data-fr-product-payment-terms]');
    for (var i = 0; i < els.length; i++) {
      /* inline display, not the hidden attribute: nothing in the theme can
         out-specify it, and it survives the buy box's own class churn */
      els[i].style.display = hide ? 'none' : '';
      els[i].setAttribute('data-fr-subscription-selected', hide ? 'true' : 'false');
    }
  }

  var pending = [];
  function schedule() {
    while (pending.length) clearTimeout(pending.pop());
    RECHECK_MS.forEach(function (d) { pending.push(setTimeout(apply, d)); });
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.name) return;
    if (t.name === 'selling_plan' || t.name.indexOf('purchaseOption') === 0) schedule();
  }, true);

  /* Some builds of the widget swap the radio rather than firing change on it,
     so a click anywhere in the purchase-option group also triggers a re-check. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (event.target.closest('.shopify_subscriptions_app_block, .shopify_subscriptions_app_container')) {
      schedule();
    }
  }, true);

  function watchWidget() {
    var widget = document.querySelector(
      '.shopify_subscriptions_app_container, .shopify_subscriptions_app_block'
    );
    if (!widget) return;
    var debounce = null;
    new MutationObserver(function () {
      if (debounce) return;
      debounce = setTimeout(function () { debounce = null; apply(); }, 150);
    }).observe(widget, { childList: true, subtree: true });
  }

  function start() {
    apply();
    watchWidget();
    /* the app block hydrates after the theme, so re-check once it has settled */
    schedule();
  }

  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
